export default {
   
    SET_DECLARE({commit},declareCompany){
        commit('SET_DECLARE',declareCompany)
    },
    SET_BIRTH_COUNTRY_DIRECTOR({commit}, birthCountryDirector){
        commit('SET_BIRTH_COUNTRY_DIRECTOR', birthCountryDirector)
    }
   
}